import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SessionStorageKeys } from '@common/constants';

type UserType = 'azure' | 'google' | 'non-federated';

interface ParsedParamsResult {
  parsed: boolean;
  federatedUserLogout: boolean;
  userType: UserType;
}

export default function useParamsParse(): ParsedParamsResult {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const agencies = query.get('agency');
  const facility = query.get('facility_id');
  const isNonFederatedUser = query.get('is_non_federated_user');
  const isGoogleUser = query.get('is_google_user');
  const federatedUserLogout = !!query.get('logout');

  let userType: UserType = 'azure';

  if (isNonFederatedUser === 'True') userType = 'non-federated';
  if (isGoogleUser === 'True') userType = 'google';

  useEffect(() => {
    if (agencies && facility) {
      sessionStorage.setItem(SessionStorageKeys.AGENCIES, agencies);
      sessionStorage.setItem(SessionStorageKeys.FACILITY, facility);
    }
  }, [agencies, facility]);

  return {
    parsed: !!(agencies && facility),
    userType,
    federatedUserLogout,
  };
}
